<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :persistenceKey="'sales-planning-list'"
    :loadDataGrid="loaded"
    ref="sales-planning-list"
    v-if="loaded"
  >
    <template #popup>
      <GcPopUpWorkOrder
        :popupConfig="popup"
        :on-hide="onPopupHide"
        :wrapper-attr="{
          class: 'css-v2 gc-popup gc-popup-form gc-popup-work-order',
        }"
        :data-model="dataModel"
        :show-loading="showLoading"
        :width="1024"
        :height="370"
        :save-call-back="onWorkOrderSave"
        :displayServerError="displayServerErrorOnTemplate"
        v-if="popup.isPopupShow"
      />

      <GcSalesPlanningStatus
        :popupConfig="popupConfig"
        :on-hide="onPopupHide"
        :width="1024"
        :height="370"
        :show-loading="showLoading"
        :save-call-back="onPTStatusSave"
        :displayServerError="displayServerErrorOnTemplate"
        v-if="popupConfig.isPopupShow"
      />
    </template>
  </TransactionListTemplate>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import { SalesOrderListService } from "../../_services/api/sales/sales-order-list.service";
import { CacheService } from "../../_services/cache/cache-service";
import {
  SalesOrderTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/sales/salesorder-tabs";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { WorkOrderService } from "../../_services/api/production/work-order.service";
import { FeatureStorage } from "../../_services/storage";
import GcSalesPlanningStatus from "../../popups/gc-popup-sales-planning-status";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
    GcSalesPlanningStatus,
  },
  data() {
    return {
      setLoading: false,
      CustomerSalesRepresentativeCode: undefined,
      loaded: false,
      popup: {
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 370,
        isPopupShow: false,
        hideOnOutsideClick: false,
        formMode: "create",
        isEditable: false,
      },
      dataModel: undefined,

      popupConfig: {
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 65,
        isPopupShow: false,
        hideOnOutsideClick: false,
        formMode: "create",
        isEditable: false,
        SalesOrderDetailRecordIdList: [],
        Attribute: undefined,
      },
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Sales Orders",
        ScreenName: "Sales Orders - Planning",
        selectedIndex: GetIndexByTabName("Planning"),
        tabs: SalesOrderTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "SalesOrderDetailCompanyBranch",
              filter: [["ItemType", "=", "S"]],
              serverPaging: true,
              allowGrouping: false,
              select: [
                "SalesOrderCode",
                "CustomerCode",
                "CustomerName",
                "CustomerOrder",
                "LineNo",
                "ItemCode",
                "Description1",
                "MarketCode",
                "ShipDate",
                "WorkOrderCode",
                "WorkOrderPackDate",
                "SalesOrderFriendlyStatus",
                "BranchCode",
                "TransportStatus",
                "ProductionStatus",
                "RecordId",
                "ProductionStatusHexColour",
                "TransportStatusHexColour",
                "ItemType",
              ],
            },
            // noDataMessage: {
            //   addNew: {
            //     class: "add-new",
            //     title: "No Orders",
            //     message: "Get Started, Add an Order",
            //   },
            // },
            options: {
              selectionMode: "multiple",
              // pageSize: 50,
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            filterOnEnter: true,
            customButtons: [
              {
                icon: "more",
                widget: "dxDropDownButton",
                label: "",
                clickAction: {},
                buttonLocation: "right",
                options: {
                  icon: "more",
                  showArrowIcon: false,
                  keyExpr: "menuText",
                  displayExpr: "menuText",
                  dropDownOptions: { width: 150 },
                  items: [
                    {
                      menuText: "Production Status",
                    },
                    {
                      menuText: "Transport Status",
                    },
                  ],
                  onItemClick: this.updatePTStatus,
                  disabled: !FeatureStorage.checkPermission(
                    "SalesOrderPlanning",
                    "create"
                  ),
                },
              },
            ],
          },
          columns: [
            {
              screenField: "SalesOrder",
              gridDataField: "SalesOrderCode",
              dataField: "SalesOrderCode",
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              width: ColumnWidth.SalesOrderCode.width,
              maxWidth: ColumnWidth.SalesOrderCode.minWidth,
              hyperlink: {
                url: "sales-order/review/__ID__",
                target: "_blank",
              },
            },
            {
              screenField: "Code",
              filterLabel: "Sales Order",
              showInColumnChooser: false,
              visible: false,
              type: "Integer",
              filterIndex: 0,
              width: ColumnWidth.SalesOrderCode.width,
              maxWidth: ColumnWidth.SalesOrderCode.minWidth,
              filterDataField: "SalesOrderCode",
            },
            {
              screenField: "Customer",
              filterIndex: 2,
              allowHiding: false,
            },
            {
              screenField: "CustPO",
              gridDataField: "CustomerOrder",
              filterDataField: "CustomerOrder",
              dataType: "string",
              type: "Text",
              filterIndex: 1,
              width: ColumnWidth.CustPO.width,
              maxWidth: ColumnWidth.CustPO.minWidth,
            },
            {
              screenField: "LineComment",
              gridLabel: "Line #",
              dataField: "LineNo",
              width: ColumnWidth.LineInfo.width - 20,
              minWidth: ColumnWidth.LineInfo.minWidth - 20,
              alignment: "left",
              allowSorting: true,
            },

            {
              screenField: "Product",
              gridDataField: "Description1",
              allowHiding: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "Description1",
                  },
                ],
                secondary: [
                  {
                    dataField: "ItemCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "ItemCode",
                  label: "Product Code",
                },
                {
                  dataField: "Description1",
                  label: "Product Description",
                },
              ],
            },
            {
              screenField: "Market",
              gridDataField: "MarketCode",
              width: ColumnWidth.Market.width,
              maxWidth: ColumnWidth.Market.minWidth,
              filterDataField: "MarketCode",
              filterIndex: 9,
              visible: false,
            },
            {
              screenField: "ShipDate",
              gridLabel: "Ship Date",
              filterDataField: "ShipDate",
              filterIndex: 3,
              width: ColumnWidth.Date.width,
              maxWidth: ColumnWidth.Date.minWidth,
              sortOrder: "asc",
              sortIndex: 1,
              allowHiding: false,
            },
            {
              screenField: "WorkOrder",
              gridDataField: "WorkOrderCode",
              width: ColumnWidth.WorkOrder.width,
              maxWidth: ColumnWidth.WorkOrder.minWidth,
              cellTemplate: undefined,
              hyperlink: true,
              hyperLinkCallBack: this.hyperLinkCallBack,
              allowHiding: false,
            },
            {
              screenField: "RequiredByDate",
              gridLabel: "Pack Date",
              filterLabel: "Pack Date",
              gridDataField: "WorkOrderPackDate",
              filterDataField: "WorkOrderPackDate",
              width: ColumnWidth.Date.width,
              maxWidth: ColumnWidth.Date.minWidth,
              sortOrder: "asc",
              sortIndex: 0,
              allowHiding: false,
              filterIndex: 4,
            },
            {
              screenField: "ProductionStatus",
              width: 120,
              filterIndex: 6,
              customBackGroundColor: (data) => {
                if (data) return data.ProductionStatusHexColour;
                else return undefined;
              },
            },
            {
              screenField: "TransportStatus",
              filterIndex: 7,
              customBackGroundColor: (data) => {
                if (data) return data.TransportStatusHexColour;
                else return undefined;
              },
            },
            {
              screenField: "Branch",
              filterDataField: "BranchCode",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 5,
            },
            {
              screenField: "OrderStatus",
              filterDataField: "SalesOrderFriendlyStatus",
              filterIndex: 8,
              visible: false,
              showInColumnChooser: false,
              dataSourceConfig: {
                data: [
                  "Active",
                  "Cancelled",
                  "Completed",
                  "Draft",
                  "Locked",
                  "On Hold",
                  "Pending",
                ],
              },
              filterDefaultValue: ["Active", "Locked"],
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Production Status",
                      data: data,
                      clickAction: this.updateProductionStatus,
                      disabled: !!data.data.WorkOrderCode,
                    },
                    {
                      menuText: "Transport Status",
                      data: data,
                      clickAction: this.updateTransportStatus,
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: () => {
                return !FeatureStorage.checkPermission(
                  "SalesOrderPlanning",
                  "create"
                );
              },
            },
          ],
        },
      };

      return config;
    },
    getCustomerRepDefault() {
      if (this.CustomerSalesRepresentativeCode)
        return [this.CustomerSalesRepresentativeCode];
      else return false;
    },
  },
  methods: {
    updatePTStatus(e) {
      let selectedRows =
        this.$refs["sales-planning-list"].$refs[
          "transactionListGrid"
        ].selectedRowData();

      if (selectedRows.length > 0) {
        selectedRows.forEach((element) => {
          this.popupConfig.SalesOrderDetailRecordIdList.push(
            element.RecordId._value
          );
        });
        if (e.itemData.menuText == "Production Status") {
          this.updateProductionStatus();
        } else {
          this.updateTransportStatus();
        }
      } else {
        this.$alert(
          "At least one sales order line should be selected.",
          "Update Failed"
        );
      }
    },
    updateProductionStatus(e) {
      this.popupConfig.title = "Update Production Status";
      this.popupConfig.Attribute = "ProductionStatus";
      if (e)
        this.popupConfig.SalesOrderDetailRecordIdList.push(e.RecordId._value);
      this.popupConfig.isPopupShow = true;
    },
    updateTransportStatus(e) {
      this.popupConfig.title = "Update Transport Status";
      this.popupConfig.Attribute = "TransportStatus";
      if (e)
        this.popupConfig.SalesOrderDetailRecordIdList.push(e.RecordId._value);
      this.popupConfig.isPopupShow = true;
    },
    /**
     * Show Loading
     * @param value
     * @constructor
     */
    showLoading(value) {
      this.setLoading = value;
    },

    /**
     * Hide work order popup
     */
    onPopupHide() {
      this.popup.isPopupShow = false;
      this.popupConfig.isPopupShow = false;
      this.popupConfig.SalesOrderDetailRecordIdList = [];
    },

    /**
     * call back after wo-model save event
     */
    onWorkOrderSave() {
      this.onPopupHide();
      this.showLoading(true);
    },

    onPTStatusSave() {
      this.onPopupHide();
      let dataGrid =
        this.$refs["sales-planning-list"].$refs[
          "transactionListGrid"
        ].getGridInstance();
      if (dataGrid) {
        dataGrid.deselectAll();
      }

      this.$refs["sales-planning-list"].$refs[
        "transactionListGrid"
      ].gridRepaint();
    },

    /**
     * display server error
     * @param err
     * @param msg
     */
    displayServerErrorOnTemplate(err, msg) {
      this.$store.dispatch("ui/setServerError", {
        error: err,
        title: msg,
      });
    },

    /**
     * grid table row call back
     */
    rowClickCallBack() {
      return false;
    },
    async setDefaultCustomerRep() {
      var defaultSalesRep = CacheService.getCache(
        "UserDefaultSalesRepresentative"
      );

      if (!defaultSalesRep) {
        await SalesOrderListService.getUserDefaultSalesRepresentative()
          .then((result) => {
            this.setLoading = false;
            if (result.data.value[0].SalesRepresentativeCode != "") {
              this.CustomerSalesRepresentativeCode =
                result.data.value[0].SalesRepresentativeCode;
            }

            CacheService.saveCache(
              "UserDefaultSalesRepresentative",
              result.data.value[0],
              2
            );
            this.loaded = true;
          })
          .catch((err) => {
            if (err) {
              this.setLoading = false;
              this.loaded = true;
            }
          });
      } else {
        if (defaultSalesRep.SalesRepresentativeCode != "")
          this.CustomerSalesRepresentativeCode =
            defaultSalesRep.SalesRepresentativeCode;

        this.loaded = true;
      }
    },

    /**
     * Hyperlink call back for visible wo-popup model
     */
    async hyperLinkCallBack(data) {
      let rowData = data.data;
      const response = await WorkOrderService.getByCode(rowData.WorkOrderCode);
      const workOrderDetail = response.data.value[0];
      this.dataModel = workOrderDetail;
      // this.dataModel.FriendlyStatus = rowData.SalesOrderFriendlyStatus;

      this.popup.title = `Work Order #${workOrderDetail.Code}`;
      this.popup.workOrderCode = workOrderDetail.Code;
      this.popup.secondaryTitle =
        rowData.ItemCode + " - " + rowData.Description1;
      this.popup.isEditable =
        (this.dataModel.FriendlyStatus === "Active" ||
          this.dataModel.FriendlyStatus === "In Production") &&
        FeatureStorage.checkPermission("WorkOrder", "edit");

      this.showModalReview();
    },

    /**
     * Show Modal Review
     */
    showModalReview() {
      this.popup.hideOnOutsideClick = true;
      this.popup.formMode = "review";
      this.popup.popupKey++;
      this.popup.isPopupShow = true;
    },
  },

  async created() {
    this.setLoading = true;
    await this.setDefaultCustomerRep();
  },
};
</script>

<style lang="scss"></style>
